import { render, staticRenderFns } from "./Tms.vue?vue&type=template&id=f18f3924&scoped=true&"
import script from "./Tms.vue?vue&type=script&lang=js&"
export * from "./Tms.vue?vue&type=script&lang=js&"
import style0 from "./Tms.vue?vue&type=style&index=0&id=f18f3924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18f3924",
  null
  
)

/* custom blocks */
import block0 from "./Tms.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports